module.exports = __webpack_public_path__ + "img/login2.1de1db05.png";